import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { api, setToken, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.login(email, password);
      setToken(data?.token);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain relative flex min-h-screen items-center justify-center overflow-hidden bg-[var(--bg)] px-5 text-white">
      <div className="absolute -left-40 top-10 h-[480px] w-[480px] rounded-full bg-[var(--vio)]/25 blur-[140px]" />
      <div className="absolute -right-40 bottom-0 h-[420px] w-[420px] rounded-full bg-[var(--mag)]/20 blur-[140px]" />
      <motion.form initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }} onSubmit={submit} data-testid="admin-login-form" className="relative w-full max-w-md space-y-6 rounded-3xl border border-white/10 bg-[var(--surface)]/80 p-8 backdrop-blur-xl sm:p-10">
        <Link to="/" data-testid="admin-login-home-link"><img src="/img/logo-sm.webp" alt="Bridgeway Auto" className="mx-auto h-20 w-auto" /></Link>
        <div>
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-[var(--pink-text)]"><Lock className="h-4 w-4" /> Owner portal</div>
          <h1 className="font-race mt-3 text-5xl">Sign in</h1>
        </div>
        <div className="space-y-2">
          <Label className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400">Email</Label>
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl border-white/10 bg-black/40 text-white" data-testid="login-email-input" />
        </div>
        <div className="space-y-2">
          <Label className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400">Password</Label>
          <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl border-white/10 bg-black/40 text-white" data-testid="login-password-input" />
        </div>
        {error && <p data-testid="login-error" className="rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">{error}</p>}
        <button type="submit" disabled={loading} data-testid="login-submit-button" className="btn-neon flex w-full items-center justify-center gap-2 rounded-full py-4 text-sm font-bold uppercase tracking-[0.2em] disabled:opacity-60">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </motion.form>
    </div>
  );
}
